<div class="row mt-24">
  <div class="col-12" data-testid="erp-outbound-filter-modal-report-list">
    <app-erp-outbound-report-grouped-list/>
  </div>
</div>
